'use client';
import * as React from 'react';
import { usePathname } from 'next/navigation';

export const useCurrentPath = (mainPath?: string): [boolean, (path: string) => boolean] => {
  const currentPath = usePathname();

  const isCurrentPath = React.useCallback((path: string) => currentPath === path, [currentPath]);

  return [currentPath === mainPath, isCurrentPath];
};
